/* eslint comma-dangle: ["error", "always-multiline"] */

import { equipmentPrettyType } from 'Utils/filters.js';

export default {
  paginationPageSizes: [50, 100, 200, 500], // eslint-disable-line no-magic-numbers
  enableFiltering: true,
  showGridFooter: false,
  showColumnFooter: true,
  columnDefs: [
    {
      field: 'name',
      displayName: 'Name',
      enableHiding: false,
      cellTooltip: true,
      width: 200,
      // Natural sort (to handle eg "Thing 10" > "Thing 2")
      sortingAlgorithm: (a, b) => a.localeCompare(b, undefined, { numeric: true }),
    },
    {
      field: 'equipmentType',
      displayName: 'Type',
      cellFilter: 'equipmentPrettyType',
      enableHiding: false,
      width: '*',
      filter: {
        // This lets us filter by raw AND pretty type vs enabling filterCellFiltered
        condition: (searchTerm, type) => {
          const exp = new RegExp(searchTerm, 'i');
          return exp.test(type) || exp.test(equipmentPrettyType(type));
        },
      },
      sortingAlgorithm: (a, b) => equipmentPrettyType(a).localeCompare(equipmentPrettyType(b)),
    },
    {
      field: 'id',
      displayName: '',
      enableCellEdit: false,
      enableHiding: false,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate:
        `<a
          ng-hide="row.entity.equipmentType === 'RCU'"
          class="btn btn-block"
          ui-sref="equipment({ id: row.entity.id })"
          uib-tooltip="{{'Open ' + row.entity.name + ' for editing'}}"
          tooltip-placement="auto"
        ><i class="fas fa-external-link-alt"></i></a>`,
      width: 75,
    },
  ],
  enableRowSelection: false,
  enableSelectAll: false,
  // Note that the selectAll does not watch for new data,
  // so you need to manually call grid.api.selection.selectAllVisibleRows if new data has been added.
  multiSelect: false,
  modifierKeysToMultiSelect: true,
  gridMenuShowHideColumns: false,
  enableRowHeaderSelection: false,
  enableColumnResizing: true,
  flatEntityAccess: true,
  rowHeight: 32, // Just slightly larger than default to accommodate buttons
};
